//
//
//
//
//
//
//
//
//
//
//
//
//

import VueContentLoading from "vue-content-loading";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "BoardsSelectLoader",
  components: {
    VueContentLoading
  }
});